import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { app } from "@/di";
import SettingRepository from "@/modules/settings/services/SettingRepository";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const settingRepository = app.get(SettingRepository);
    const form = ref({
      game_id: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('game_id')), __temp = await __temp, __restore(), __temp),
      auto_save: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('auto_save')), __temp = await __temp, __restore(), __temp),
      stop_evaluation_on_start_of_the_week: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('stop_evaluation_on_start_of_the_week')), __temp = await __temp, __restore(), __temp),
      match_evaluation_fast_speed: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('match_evaluation_fast_speed')), __temp = await __temp, __restore(), __temp),
      match_evaluation_show_incidents: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('match_evaluation_show_incidents')), __temp = await __temp, __restore(), __temp)
    });
    const rules = ref({
      game_id: {
        type: 'string',
        required: true
      },
      auto_save: {
        type: 'boolean',
        required: true
      },
      stop_evaluation_on_start_of_the_week: {
        type: 'boolean',
        required: true
      },
      match_evaluation_fast_speed: {
        type: 'boolean',
        required: true
      },
      match_evaluation_show_incidents: {
        type: 'boolean',
        required: true
      }
    });
    const message = useMessage();
    const onSubmit = async () => {
      await Object.keys(form.value).forEachAsync(key => settingRepository.set(key, form.value[key]));
      message.success(translator.t('saved'));
    };
    return (_ctx, _cache) => {
      const _component_NInput = _resolveComponent("NInput");
      const _component_NFormItem = _resolveComponent("NFormItem");
      const _component_NCheckbox = _resolveComponent("NCheckbox");
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_NButton = _resolveComponent("NButton");
      const _component_NForm = _resolveComponent("NForm");
      return _openBlock(), _createBlock(_component_NForm, {
        ref: "formComponent",
        model: form.value,
        rules: rules.value,
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [_createVNode(DefaultInGameLayout, null, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('settings')), 1)]),
          footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
            secondary: "",
            size: "large",
            type: "primary",
            "attr-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('save')), 1)]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_NFormItem, {
            label: _ctx.$t('game_id'),
            path: "form.game_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_NInput, {
              value: form.value.game_id,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => form.value.game_id = $event),
              placeholder: _ctx.$t('game_id'),
              readonly: ""
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_NFormItem, {
            label: _ctx.$t('auto_save'),
            path: "form.auto_save"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.auto_save,
              "onUpdate:checked": _cache[1] || (_cache[1] = $event => form.value.auto_save = $event)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('auto_save')), 1)]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_NFormItem, {
            label: _ctx.$t('stop_evaluation_on_start_of_the_week'),
            path: "form.stop_evaluation_on_start_of_the_week"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.stop_evaluation_on_start_of_the_week,
              "onUpdate:checked": _cache[2] || (_cache[2] = $event => form.value.stop_evaluation_on_start_of_the_week = $event)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('stop_evaluation_on_start_of_the_week')), 1)]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_NDivider, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('match_evaluation')), 1)]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: _ctx.$t('fast_speed'),
            path: "form.fast_speed"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.match_evaluation_fast_speed,
              "onUpdate:checked": _cache[3] || (_cache[3] = $event => form.value.match_evaluation_fast_speed = $event)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('fast_speed')), 1)]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_NFormItem, {
            label: _ctx.$t('show_incidents'),
            path: "form.show_incidents"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.match_evaluation_show_incidents,
              "onUpdate:checked": _cache[4] || (_cache[4] = $event => form.value.match_evaluation_show_incidents = $event)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('show_incidents')), 1)]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]);
    };
  }
});